import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitQuote = (data) => axios.post(`${API}/quotes`, data).then((r) => r.data);
export const submitContact = (data) => axios.post(`${API}/contacts`, data).then((r) => r.data);
export const submitComplaint = (data) => axios.post(`${API}/complaints`, data).then((r) => r.data);
